<template>
    <div class="content-timeline" :class="resizeClass">
      <h2>Timeline</h2>

      <div class="timeline-item">
        <div class="item-number">01</div>
        <div class="item-container">
          <h3>Pré-qualificação</h3>
          <button v-b-toggle.collapse-1 variant="primary" @click="changePrequalificacaoCollapse()"><i :class="prequalificacaoCollapse ? 'icon-arrow-1-up' : 'icon-arrow-1-down'"></i></button>
          <div class="button-text">{{ prequalificacaoCollapse ? 'Fechar' : 'Abrir' }}</div>
          <b-collapse id="collapse-1">
            <b-card class="">
              <div v-for="(i, index) in prequalificacao" v-bind:key="i.id">
                <div class="timeline-container">
                  <div class="timeline-icon"></div>
                  <div class="timeline-body mb-3">
                    <div class="timeline-box">

                      <div class="wrapper d-flex justify-content-between">
                        <h3 class="">{{ i.title }}</h3>
                        <p>{{ i.date | moment-complete }}</p>
                      </div>

                      <div v-if="i.dateSettled !== null">
                        <p class="card-subtitle mt-1 mb-2 text-muted">{{ i.dateSettled !== null ? i.dateSettled : '' }}</p>
                      </div>
                      <p class="m-0"><strong :class="i.description === 'Status: ELIGIBLE' ? 'text-success' : ''">{{ i.description !== null ? i.description  : '' }} {{ i.reason ? ' - ' + i.reason : ''}}</strong></p>
                      <div v-for="(v, k) in i.itens" v-bind:key="k">
                        <p class="m-0" v-if="k == 'Link'">
                          <a :href="v" target="_blank">
                            <span class="mr-1 text-primary"><i class="fa fa-link"></i></span>
                            <span class="">Link do boleto</span>
                          </a>
                        </p>
                        <p class="m-0" v-else>{{k}}: {{v}}</p>
                      </div>

                      <div class="custom-container mb-3 mt-3" v-if="i.code">

                        <div class="custom-container-header">
                          <b-button type="button" variant="" class="btn-sm mt-1 mb-1" v-b-toggle="'collapse' + i.title + index"><i class="icon-arrow-1-down"></i></b-button>
                        </div>
                        <b-collapse :id="'collapse' + i.title + index" class="mt-2">
                          <div class="custom-container mb-3">
                            <div style="max-width: 600px;">
                              <p class="card-text"><pre><code>{{ i.code }}</code></pre></p>
                            </div>
                          </div>
                        </b-collapse>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!--<p><strong>Status:</strong>Elegível</p>-->
            </b-card>
          </b-collapse>
        </div>
      </div>

      <div class="timeline-item">
        <div class="item-number">02</div>
        <div class="item-container">
          <h3>Iniciado</h3>
          <button v-b-toggle.collapse-2 variant="primary" @click="changeIniciadoCollapse()"><i :class="iniciadoCollapse ? 'icon-arrow-1-up' : 'icon-arrow-1-down'"></i></button>
          <div class="button-text">{{ iniciadoCollapse ? 'Fechar' : 'Abrir' }}</div>
          <b-collapse id="collapse-2">
            <b-card>
              <div v-for="(i, index) in iniciado" v-bind:key="i.id">
                <div class="timeline-container">
                  <div class="timeline-icon"></div>
                  <div class="timeline-body mb-3">
                    <div class="timeline-box">

                      <div class="wrapper d-flex justify-content-between">
                        <h3 class="">{{ i.title }}</h3>
                        <p>{{ i.date | moment-complete }}</p>
                      </div>

                      <div v-if="i.dateSettled !== null">
                        <p class="card-subtitle mt-1 mb-2 text-muted">{{ i.dateSettled !== null ? i.dateSettled : '' }}</p>
                      </div>
                      <p class="m-0"><strong :class="i.description === 'Status: ELIGIBLE' ? 'text-success' : ''">{{ i.description !== null ? i.description  : '' }} {{ i.reason ? ' - ' + i.reason : ''}}</strong></p>
                      <div v-for="(v, k) in i.itens" v-bind:key="k">
                        <p class="m-0" v-if="k == 'Link'">
                          <a :href="v" target="_blank">
                            <span class="mr-1 text-primary"><i class="fa fa-link"></i></span>
                            <span class="">Link do boleto</span>
                          </a>
                        </p>
                        <p class="m-0" v-else>{{k}}: {{v}}</p>
                      </div>

                      <div class="custom-container mb-3 mt-3" v-if="i.code">

                        <div class="custom-container-header">
                          <b-button type="button" variant="" class="btn-sm mt-1 mb-1" v-b-toggle="'collapse' + i.title + index"><i class="icon-arrow-1-down"></i></b-button>
                        </div>
                        <b-collapse :id="'collapse' + i.title + index" class="mt-2">
                          <div class="custom-container mb-3">
                            <div style="max-width: 600px;">
                              <p class="card-text"><pre><code>{{ i.code }}</code></pre></p>
                            </div>
                          </div>
                        </b-collapse>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-card>
          </b-collapse>
        </div>
      </div>

      <div class="timeline-item">
        <div class="item-number">03</div>
        <div class="item-container">
          <h3>Análise</h3>
          <button v-b-toggle.collapse-3 variant="primary" @click="changeAnaliseCollapse()"><i :class="analiseCollapse ? 'icon-arrow-1-up' : 'icon-arrow-1-down'"></i></button>
          <div class="button-text">{{ analiseCollapse ? 'Fechar' : 'Abrir' }}</div>
          <b-collapse id="collapse-3">
            <b-card>
              <div v-for="(i, index) in analise" v-bind:key="i.id">
                <div class="timeline-container">
                  <div class="timeline-icon"></div>
                  <div class="timeline-body mb-3">
                    <div class="timeline-box">

                      <div class="wrapper d-flex justify-content-between">
                        <h3 class="">{{ i.title }}</h3>
                        <p>{{ i.date | moment-complete }}</p>
                      </div>

                      <div v-if="i.dateSettled !== null">
                        <p class="card-subtitle mt-1 mb-2 text-muted">{{ i.dateSettled !== null ? i.dateSettled : '' }}</p>
                      </div>
                      <p class="m-0"><strong :class="i.description === 'Status: ELIGIBLE' ? 'text-success' : ''">{{ i.description !== null ? i.description  : '' }} {{ i.reason ? ' - ' + i.reason : ''}}</strong></p>
                      <div v-for="(v, k) in i.itens" v-bind:key="k">
                        <p class="m-0" v-if="k == 'Link'">
                          <a :href="v" target="_blank">
                            <span class="mr-1 text-primary"><i class="fa fa-link"></i></span>
                            <span class="">Link do boleto</span>
                          </a>
                        </p>
                        <p class="m-0" v-else>{{k}}: {{v}}</p>
                      </div>

                      <div class="custom-container mb-3 mt-3" v-if="i.code">

                        <div class="custom-container-header">
                          <b-button type="button" variant="" class="btn-sm mt-1 mb-1" v-b-toggle="'collapse' + i.title + index"><i class="icon-arrow-1-down"></i></b-button>
                        </div>
                        <b-collapse :id="'collapse' + i.title + index" class="mt-2">
                          <div class="custom-container mb-3">
                            <div style="max-width: 600px;">
                              <p class="card-text"><pre><code>{{ i.code }}</code></pre></p>
                            </div>
                          </div>
                        </b-collapse>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!--
              <p class="card-text">Collapse contents Here</p>
              <b-button v-b-toggle.collapse-3-inner size="sm">Toggle Inner Collapse</b-button>
              <b-collapse id="collapse-3-inner">
                <b-card>Hello!</b-card>
              </b-collapse>
              -->
            </b-card>
          </b-collapse>
        </div>
      </div>

      <div class="timeline-item">
        <div class="item-number">04</div>
        <div class="item-container">
          <h3>Contrato</h3>
          <button v-b-toggle.collapse-4 variant="primary" @click="changeContratoCollapse()"><i :class="contratoCollapse ? 'icon-arrow-1-up' : 'icon-arrow-1-down'"></i></button>
          <div class="button-text">{{ contratoCollapse ? 'Fechar' : 'Abrir' }}</div>
          <b-collapse id="collapse-4">
            <b-card>
              <div v-for="(i, index) in contrato" v-bind:key="i.id">
                <div class="timeline-container">
                  <div class="timeline-icon"></div>
                  <div class="timeline-body mb-3">
                    <div class="timeline-box">

                      <div class="wrapper d-flex justify-content-between">
                        <h3 class="">{{ i.title }}</h3>
                        <p>{{ i.date | moment-complete }}</p>
                      </div>

                      <div v-if="i.dateSettled !== null">
                        <p class="card-subtitle mt-1 mb-2 text-muted">{{ i.dateSettled !== null ? i.dateSettled : '' }}</p>
                      </div>
                      <p class="m-0"><strong :class="i.description === 'Status: ELIGIBLE' ? 'text-success' : ''">{{ i.description !== null ? i.description  : '' }} {{ i.reason ? ' - ' + i.reason : ''}}</strong></p>
                      <div v-for="(v, k) in i.itens" v-bind:key="k">
                        <p class="m-0" v-if="k == 'Link'">
                          <a :href="v" target="_blank">
                            <span class="mr-1 text-primary"><i class="fa fa-link"></i></span>
                            <span class="">Link do boleto</span>
                          </a>
                        </p>
                        <p class="m-0" v-else>{{k}}: {{v}}</p>
                      </div>

                      <div class="custom-container mb-3 mt-3" v-if="i.code">

                        <div class="custom-container-header">
                          <b-button type="button" variant="" class="btn-sm mt-1 mb-1" v-b-toggle="'collapse' + i.title + index"><i class="icon-arrow-1-down"></i></b-button>
                        </div>
                        <b-collapse :id="'collapse' + i.title + index" class="mt-2">
                          <div class="custom-container mb-3">
                            <div style="max-width: 600px;">
                              <p class="card-text"><pre><code>{{ i.code }}</code></pre></p>
                            </div>
                          </div>
                        </b-collapse>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-card>
          </b-collapse>
        </div>
      </div>

      <div class="timeline-item">
        <div class="item-number">05</div>
        <div class="item-container">
          <h3>Verificação</h3>
          <button v-b-toggle.collapse-5 variant="primary" @click="changeVerificacaoCollapse()"><i :class="verificacaoCollapse ? 'icon-arrow-1-up' : 'icon-arrow-1-down'"></i></button>
          <div class="button-text">{{ verificacaoCollapse ? 'Fechar' : 'Abrir' }}</div>
          <b-collapse id="collapse-5">
            <b-card>
              <div v-for="(i, index) in verificacao" v-bind:key="i.id">
                <div class="timeline-container">
                  <div class="timeline-icon"></div>
                  <div class="timeline-body mb-3">
                    <div class="timeline-box">

                      <div class="wrapper d-flex justify-content-between">
                        <h3 class="">{{ i.title }}</h3>
                        <p>{{ i.date | moment-complete }}</p>
                      </div>

                      <div v-if="i.dateSettled !== null">
                        <p class="card-subtitle mt-1 mb-2 text-muted">{{ i.dateSettled !== null ? i.dateSettled : '' }}</p>
                      </div>
                      <p class="m-0"><strong :class="i.description === 'Status: ELIGIBLE' ? 'text-success' : ''">{{ i.description !== null ? i.description  : '' }} {{ i.reason ? ' - ' + i.reason : ''}}</strong></p>
                      <div v-for="(v, k) in i.itens" v-bind:key="k">
                        <p class="m-0" v-if="k == 'Link'">
                          <a :href="v" target="_blank">
                            <span class="mr-1 text-primary"><i class="fa fa-link"></i></span>
                            <span class="">Link do boleto</span>
                          </a>
                        </p>
                        <p class="m-0" v-else>{{k}}: {{v}}</p>
                      </div>

                      <div class="custom-container mb-3 mt-3" v-if="i.code">

                        <div class="custom-container-header">
                          <b-button type="button" variant="" class="btn-sm mt-1 mb-1" v-b-toggle="'collapse' + i.title + index"><i class="icon-arrow-1-down"></i></b-button>
                        </div>
                        <b-collapse :id="'collapse' + i.title + index" class="mt-2">
                          <div class="custom-container mb-3">
                            <div style="max-width: 600px;">
                              <p class="card-text"><pre><code>{{ i.code }}</code></pre></p>
                            </div>
                          </div>
                        </b-collapse>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-card>
          </b-collapse>
        </div>
      </div>

      <div class="timeline-item">
        <div class="item-number">06</div>
        <div class="item-container">
          <h3>Aprovação</h3>
          <button v-b-toggle.collapse-6 variant="primary" @click="changeAprovacaoCollapse()"><i :class="aprovacaoCollapse ? 'icon-arrow-1-up' : 'icon-arrow-1-down'"></i></button>
          <div class="button-text">{{ aprovacaoCollapse ? 'Fechar' : 'Abrir' }}</div>
          <b-collapse id="collapse-6">
            <b-card>
              <div v-for="(i, index) in aprovacao" v-bind:key="i.id">
                <div class="timeline-container">
                  <div class="timeline-icon"></div>
                  <div class="timeline-body mb-3">
                    <div class="timeline-box">

                      <div class="wrapper d-flex justify-content-between">
                        <h3 class="">{{ i.title }}</h3>
                        <p>{{ i.date | moment-complete }}</p>
                      </div>

                      <div v-if="i.dateSettled !== null">
                        <p class="card-subtitle mt-1 mb-2 text-muted">{{ i.dateSettled !== null ? i.dateSettled : '' }}</p>
                      </div>
                      <p class="m-0"><strong :class="i.description === 'Status: ELIGIBLE' ? 'text-success' : ''">{{ i.description !== null ? i.description  : '' }} {{ i.reason ? ' - ' + i.reason : ''}}</strong></p>
                      <div v-for="(v, k) in i.itens" v-bind:key="k">
                        <p class="m-0" v-if="k == 'Link' && v">
                          <a :href="v" target="_blank">
                            <span class="mr-1 text-primary"><i class="fa fa-link"></i></span>
                            <span class="">Portal de Boletos</span>
                          </a>
                          <br />
                          <a :href="v" target="_blank" class="refinan">
                            <span class="mr-1 text-primary"><i class="fa fa-link"></i></span>
                            <span class="">Refinanciamento</span>
                          </a>
                        </p>
                        <p class="m-0" v-else>{{k}}: {{v}}</p>
                      </div>

                      <div class="custom-container mb-3 mt-3" v-if="i.code">

                        <div class="custom-container-header">
                          <b-button type="button" variant="" class="btn-sm mt-1 mb-1" v-b-toggle="'collapse' + i.title + index"><i class="icon-arrow-1-down"></i></b-button>
                        </div>
                        <b-collapse :id="'collapse' + i.title + index" class="mt-2">
                          <div class="custom-container mb-3">
                            <div style="max-width: 600px;">
                              <p class="card-text"><pre><code>{{ i.code }}</code></pre></p>
                            </div>
                          </div>
                        </b-collapse>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-card>
          </b-collapse>
        </div>
      </div>

      <div class="timeline-item">
        <div class="item-number">07</div>
        <div class="item-container">
          <h3>Cobrança</h3>
          <button v-b-toggle.collapse-7 variant="primary" @click="changeCobrancaCollapse()"><i :class="cobrancaCollapse ? 'icon-arrow-1-up' : 'icon-arrow-1-down'"></i></button>
          <div class="button-text">{{ cobrancaCollapse ? 'Fechar' : 'Abrir' }}</div>
          <b-collapse id="collapse-7">
            <b-card>
              <div v-for="(i, index) in cobranca" v-bind:key="i.id">
                <div class="timeline-container">
                  <div class="timeline-icon"></div>
                  <div class="timeline-body mb-3">
                    <div class="timeline-box">

                      <div class="wrapper d-flex justify-content-between">
                        <h3 class="">{{ i.title }}</h3>
                        <p>{{ i.date | moment-complete }}</p>
                      </div>

                      <div v-if="i.dateSettled !== null">
                        <p class="card-subtitle mt-1 mb-2 text-muted">{{ i.dateSettled !== null ? i.dateSettled : '' }}</p>
                      </div>
                      <p class="m-0"><strong :class="i.description === 'Status: ELIGIBLE' ? 'text-success' : ''">{{ i.description !== null ? i.description  : '' }} {{ i.reason ? ' - ' + i.reason : ''}}</strong></p>
                      <div v-for="(v, k) in i.itens" v-bind:key="k">
                        <p class="m-0" v-if="k == 'Link'">
                          <a :href="v" target="_blank">
                            <span class="mr-1 text-primary"><i class="fa fa-link"></i></span>
                            <span class="">Link do boleto</span>
                          </a>
                        </p>
                        <p class="m-0" v-else>{{k}}: {{v}}</p>
                      </div>

                      <div class="custom-container mb-3 mt-3" v-if="i.code">

                        <div class="custom-container-header">
                          <b-button type="button" variant="" class="btn-sm mt-1 mb-1" v-b-toggle="'collapse' + i.title + index"><i class="icon-arrow-1-down"></i></b-button>
                        </div>
                        <b-collapse :id="'collapse' + i.title + index" class="mt-2">
                          <div class="custom-container mb-3">
                            <div style="max-width: 600px;">
                              <p class="card-text"><pre><code>{{ i.code }}</code></pre></p>
                            </div>
                          </div>
                        </b-collapse>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!--
              <p class="card-text">Collapse contents Here</p>
              <b-button v-b-toggle.collapse-7-inner size="sm">Toggle Inner Collapse</b-button>
              <b-collapse id="collapse-7-inner">
                <b-card>Hello!</b-card>
              </b-collapse>
              -->
            </b-card>
          </b-collapse>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  data () {
    return {
      timeline: null,
      prequalificacao: [],
      iniciado: [],
      analise: [],
      contrato: [],
      verificacao: [],
      aprovacao: [],
      cobranca: [],
      prequalificacaoCollapse: false,
      iniciadoCollapse: false,
      analiseCollapse: false,
      contratoCollapse: false,
      verificacaoCollapse: false,
      aprovacaoCollapse: false,
      cobrancaCollapse: false,
      check: {},
      socialName: null
    }
  },
  mounted () {
    this.getTimeline()
    this.updateRefinancingUrl()
  },
  updated () {
    this.updateRefinancingUrl()
  },
  methods: {
    changePrequalificacaoCollapse () {
      this.prequalificacaoCollapse = !this.prequalificacaoCollapse
    },
    changeIniciadoCollapse () {
      this.iniciadoCollapse = !this.iniciadoCollapse
    },
    changeAnaliseCollapse () {
      this.analiseCollapse = !this.analiseCollapse
    },
    changeContratoCollapse () {
      this.contratoCollapse = !this.contratoCollapse
    },
    changeVerificacaoCollapse () {
      this.verificacaoCollapse = !this.verificacaoCollapse
    },
    changeAprovacaoCollapse () {
      this.aprovacaoCollapse = !this.aprovacaoCollapse
    },
    changeCobrancaCollapse () {
      this.cobrancaCollapse = !this.cobrancaCollapse
    },
    getTimeline () {
      this.$http.get('api/transactions/' + this.$route.params.txid + '/timeline')
        .then(function (res) {
          this.timeline = res.data

          this.timeline.prequalificacao.data.forEach(d => {
            this.prequalificacao.push(d)
          })

          this.timeline.iniciado.data.forEach(d => {
            this.iniciado.push(d)
          })

          this.timeline.analise.data.forEach(d => {
            this.analise.push(d)
          })

          this.timeline.contrato.data.forEach(d => {
            this.contrato.push(d)
          })

          this.timeline.verificacao.data.forEach(d => {
            this.verificacao.push(d)
          })

          this.timeline.aprovacao.data.forEach(d => {
            this.aprovacao.push(d)
          })

          this.timeline.cobranca.data.forEach(d => {
            this.cobranca.push(d)
          })

          setTimeout(() => {
            let cadastro = ''
            let cpf = ''
            let selfie = ''
            let endereco = ''
            let credito = ''

            this.verificacao.forEach((item, index) => {
              switch (item.description) {
                case 'id_check':
                  cadastro = JSON.parse(this.verificacao[index].code)
                  break
                case 'background_check':
                  cpf = JSON.parse(this.verificacao[index].code)
                  break
                case 'face_check':
                  selfie = JSON.parse(this.verificacao[index].code)
                  break
                case 'address_check':
                  endereco = JSON.parse(`[${this.verificacao[index].code}]`)[0]
                  break
                case 'credit_check':
                  credito = JSON.parse(this.verificacao[index].code)
                  break
              }
            })

            this.check = {
              'cadastro': `${cadastro.step}: ${cadastro.status} ${cadastro.reason.name.reason.search('%') !== -1 ? cadastro.reason.name.reason.split(' ').pop() : ''}`,
              'cpf': cpf.status ? `${cpf.step}: ${cpf.status}` : 'Sem dados',
              'selfie': `${selfie.step}: ${selfie.status} ${selfie.reason.biometry.reason.search('%') !== -1 ? selfie.reason.biometry.reason.split(' ').pop() : ''}`,
              'endereco': endereco.status ? `${endereco.step}: ${endereco.status}` : 'Sem dados',
              'credito': credito.status ? `${credito.step}: ${credito.status}` : 'Sem dados'
            }

            this.$emit('check', this.check)
          }, 1000)

          this.socialName = this.iniciado[1].description
          this.$emit('emit-customer-social-name', this.socialName)
        })
        .catch(function (res) {
          console.error(res)
        })
    },
    updateRefinancingUrl () {
      let refinan = document.getElementsByClassName('refinan')
      // console.info(refinan)
      var arr = [].slice.call(refinan)
      arr.map((item) => {
        // console.info(item)
        if (item.hash) {
          let newHash = item.hash.replace('#/', '')
          // console.info('item.hash ' + item.hash)
          // console.info('newHash ' + newHash)
          item.href = process.env.REFINAN_URL + newHash
        }
      })
    }
  },
  props: ['resizeClass']
}
</script>

<style lang="scss" scoped>
.content-timeline {
  float: left;
  h2 {
    margin-top: 24px;
  }
  .timeline-item {
    border-left: solid 2px #E3ECFF;
    margin-left: 10px;
    padding-bottom: 50px;
    &:last-child {
      border: none;
    }
    .item-number {
      position: absolute;
      left: 14px;
      width: 24px;
      height: 24px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      background: #E3ECFF;
      color: #4285F4;
    }
    .item-container {
      padding: 5px 10px;
      h3 {
        font-size: 14px;
        color: #666666;
        margin: 0 0 0 8px;
        float: left;
      }
      button {
        width: 24px;
        height: 24px;
        float: right;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 5px;
        margin-top: -4px;
        padding: 0px;
        border: none;
        background: rgba(66, 133, 244, 0.2);
        color: #4285F4;
        outline: none;
      }
      .button-text {
        float: right;
        line-height: 1.4em;
        color: rgba(66, 133, 244, 0.75);
        margin-right: 4px;
      }
      .collapse {
        margin: 24px 0 0 0;
        &.show {
          border: none;
        }
        .card {
          clear: both;
          border: none;
          margin-bottom: -55px;
        }
      }
      .collapsing {
        transition: none !important;
      }
      .timeline-box {
        padding: 20px;
        border-radius: 10px;
        border: 1px solid #ebebeb;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/partial/customer/Timeline.vue